import { Controller } from "@hotwired/stimulus"


export default class extends Controller {
  static targets = ["phone", "countryCode", "emailWrapper", "email"]
  static values = { initialCountry: String }

  async connect() {
    if (!this.hasPhoneTarget) return;

    const module = await import("../vendors/intlTelInput");
    const intlTelInput = module.default || module;

    const initialCountry = (this.hasInitialCountryValue && this.initialCountryValue)
      ? this.initialCountryValue.toLowerCase()
      : "in"

    this.iti = intlTelInput(this.phoneTarget, {
      initialCountry,
      separateDialCode: true,
      nationalMode: true
    });
    this.updateUI();
    // Use a single RAF callback for both events
    const scheduleUpdate = () => requestAnimationFrame(() => this.updateUI());
    this.phoneTarget.addEventListener("countrychange", scheduleUpdate);
    this.phoneTarget.addEventListener("input", scheduleUpdate);
  }

  enforceMaxLength(digits, iso) {
    const max = iso === "in" ? 10 : 15
    if (digits.length > max) digits = digits.slice(0, max)
    return digits
  }

  updateUI() {
    const country = this.iti.getSelectedCountryData()
    const iso = country.iso2

    // sanitize to digits only
    let digits = this.phoneTarget.value.replace(/\D/g, "")

    // Normalize common Indian prefixes and enforce exact 10-digit national number
    if (iso === "in") {
      // drop leading zeros
      digits = digits.replace(/^0+/, "")
      // Handle pastes that include country code variants (91, 091, 0091)
      if (digits.length > 10) digits = digits.replace(/^(?:91|091|0091)/, "")
    }

    digits = this.enforceMaxLength(digits, iso)

    // Only write if value changed
    if (this.phoneTarget.value !== digits) {
      this.phoneTarget.value = digits
    }

    const dialCode = `+${country.dialCode}`
    const isIN = iso === "in"

    // Hard-limit input length at the element level as well
    this.phoneTarget.maxLength = isIN ? 10 : 15

    // For Indian numbers, require exactly 10 digits
    if (isIN) {
      this.phoneTarget.setCustomValidity(digits.length === 10 ? "" : "Phone number must be exactly 10 digits")
    } else {
      this.phoneTarget.setCustomValidity("")
    }

    if (this.hasCountryCodeTarget) this.countryCodeTarget.value = dialCode
    if (this.hasEmailWrapperTarget && this.hasEmailTarget) {
      this.emailWrapperTarget.style.display = isIN ? "none" : "block"
      this.emailTarget.required = !isIN
    }
  }
}
